const PALETTE_SIZE = 16;

/** Series with no chapter of their own (unfiled, bought-in) share a neutral that no chapter takes. */
export const chapterColor = (slot: number | undefined): string =>
  slot === undefined ? 'var(--muted-foreground)' : `var(--chapter-${(slot % PALETTE_SIZE) + 1})`;

export const chapterSlots = (chapters: { key: string; colorSlot?: number }[]): Map<string, number | undefined> =>
  new Map(chapters.map(chapter => [chapter.key, chapter.colorSlot]));

/** Stacks by slot, so chapters sit in the same order on every product; unslotted rows go on top. */
export const bySlot =
  (slots: Map<string, number | undefined>) =>
  (a: { key: string }, b: { key: string }): number =>
    (slots.get(a.key) ?? Infinity) - (slots.get(b.key) ?? Infinity);
